import {
    StyleSheet
} from "react-native";
import type {
    StatTileTitleDynamicStyleType
} from "./type";

const stylesheet = StyleSheet.create({
    container: {
        alignItems: "center",
        flexDirection: "row",
        minWidth: 0
    },
    text: {
        flexShrink: 1
    }
});

export const useStyles = ({
    spaces
}: StatTileTitleDynamicStyleType) => {
    const styles = {
        container: {
            gap: spaces.spacingSm
        }
    };

    return styles;
};
export default stylesheet;
